import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "vld-parent" }, null, -1)
const _hoisted_2 = { class: "dashboard" }
const _hoisted_3 = { class: "machine" }
const _hoisted_4 = { class: "machine-chart" }
const _hoisted_5 = { class: "chart-box" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "chart-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Machine Status")
], -1)
const _hoisted_7 = {
  key: 1,
  class: "not-chart"
}
const _hoisted_8 = { class: "total-box" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "total-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Integration Power")
], -1)
const _hoisted_10 = { class: "total-data" }
const _hoisted_11 = { class: "warning-box" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "warning-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Error List")
], -1)
const _hoisted_13 = {
  class: "dashboard-table",
  style: {"height":"90%","overflow-y":"auto"}
}
const _hoisted_14 = { class: "table table-sm" }
const _hoisted_15 = {
  key: 0,
  class: "machine-card"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "card-title" }
const _hoisted_19 = { class: "card-title-text" }
const _hoisted_20 = {
  key: 0,
  class: "card-loading card-item"
}
const _hoisted_21 = { class: "status-text" }
const _hoisted_22 = {
  key: 1,
  class: "card-normal card-item"
}
const _hoisted_23 = { class: "status-text" }
const _hoisted_24 = {
  key: 2,
  class: "card-error card-item"
}
const _hoisted_25 = { class: "status-text" }
const _hoisted_26 = {
  key: 3,
  class: "card-warning card-item"
}
const _hoisted_27 = { class: "status-text" }
const _hoisted_28 = { class: "card-switch card-item" }
const _hoisted_29 = { class: "card-item-title" }
const _hoisted_30 = {
  key: 0,
  class: "card-item-text-value"
}
const _hoisted_31 = { class: "card-switch card-item" }
const _hoisted_32 = { class: "card-item-title" }
const _hoisted_33 = { class: "card-item-text-value" }
const _hoisted_34 = { class: "card-cycle-status card-item" }
const _hoisted_35 = { class: "card-item-title" }
const _hoisted_36 = {
  key: 0,
  class: "card-item-text-value"
}
const _hoisted_37 = { class: "card-cycle-count card-item" }
const _hoisted_38 = { class: "card-item-title" }
const _hoisted_39 = { class: "card-item-text-value" }
const _hoisted_40 = { class: "card-drytime card-item" }
const _hoisted_41 = { class: "card-item-title" }
const _hoisted_42 = { class: "card-item-text-value" }
const _hoisted_43 = { class: "card-coolingtime card-item" }
const _hoisted_44 = { class: "card-item-title" }
const _hoisted_45 = { class: "card-item-text-value" }
const _hoisted_46 = { class: "card-distime card-item" }
const _hoisted_47 = { class: "card-item-title" }
const _hoisted_48 = { class: "card-item-text-value" }
const _hoisted_49 = { class: "card-weight card-item" }
const _hoisted_50 = { class: "card-item-title" }
const _hoisted_51 = { class: "card-item-text-value" }
const _hoisted_52 = { class: "card-energy card-item" }
const _hoisted_53 = { class: "card-item-title" }
const _hoisted_54 = { class: "card-item-text-value" }
const _hoisted_55 = { class: "card-power card-item" }
const _hoisted_56 = { class: "card-item-title" }
const _hoisted_57 = { class: "card-item-text-value" }
const _hoisted_58 = { class: "card-temp card-item" }
const _hoisted_59 = { class: "card-item-title" }
const _hoisted_60 = { class: "card-item-text-value" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "detail-btn-text" }, "Detail Page", -1)
const _hoisted_63 = {
  key: 0,
  class: "machine-card-content not-data"
}
const _hoisted_64 = { class: "not-data-box" }
const _hoisted_65 = { class: "not-data-text" }
const _hoisted_66 = {
  key: 1,
  class: "machine-card-content not-data"
}
const _hoisted_67 = { class: "not-data-box" }
const _hoisted_68 = { class: "not-data-text" }
const _hoisted_69 = {
  key: 2,
  class: "machine-card-content not-data"
}
const _hoisted_70 = { class: "not-data-box" }
const _hoisted_71 = { class: "not-data-text" }
const _hoisted_72 = {
  key: 3,
  class: "machine-card-content not-data"
}
const _hoisted_73 = { class: "not-data-box" }
const _hoisted_74 = { class: "not-data-text" }
const _hoisted_75 = {
  key: 4,
  class: "machine-card-content not-data"
}
const _hoisted_76 = { class: "not-data-box" }
const _hoisted_77 = { class: "not-data-text" }
const _hoisted_78 = {
  key: 5,
  class: "machine-card-content not-data"
}
const _hoisted_79 = { class: "not-data-box" }
const _hoisted_80 = { class: "not-data-text" }
const _hoisted_81 = {
  key: 6,
  class: "machine-card-content not-data"
}
const _hoisted_82 = { class: "not-data-box" }
const _hoisted_83 = { class: "not-data-text" }
const _hoisted_84 = {
  key: 7,
  class: "machine-card-content not-data"
}
const _hoisted_85 = { class: "not-data-box" }
const _hoisted_86 = { class: "not-data-text" }
const _hoisted_87 = {
  key: 8,
  class: "machine-card-content not-data"
}
const _hoisted_88 = { class: "not-data-box" }
const _hoisted_89 = { class: "not-data-text" }
const _hoisted_90 = {
  key: 9,
  class: "machine-card-content not-data"
}
const _hoisted_91 = { class: "not-data-box" }
const _hoisted_92 = { class: "not-data-text" }

import { ref, watchEffect, computed } from "vue";
import _ from "lodash";
import { userUseStore } from "@/store/user";
import DashBoardChart from "@/components/DashBoardChart.vue";
import router from "@/router";
import { ROU_NAME } from "@/router/router.name";
import { Device } from "@/interface/device";
import AppImage from "@/components/AppImage.vue";
import Loading from "vue3-loading-overlay";
import { useOptionStore } from "@/store/option";
import { celsiusToFahrenheit } from "@/util/unit";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = userUseStore();
const optionStore = useOptionStore();

const VIEW = 4;

const boxName = ref("");

const loadings = computed(() => {
  if (userStore.realTimeData[0]) {
    return false;
  } else {
    return true;
  }
});

const dashBoardList = computed(() => {
  let list = [[]] as Device[][];
  let startIdx = 0;
  let endIdx = VIEW;
  for (let i = 0; i < Math.ceil(userStore.deviceList.length / VIEW); i++) {
    list[i] = _.slice(userStore.deviceList, startIdx, endIdx);
    startIdx += VIEW;
    endIdx += VIEW;
  }
  return list;
});

const state = ref({
  currentPage: 1,
  maxPage: 1,
  group: sessionStorage.getItem("group"),
  warningList: [] as any,
  header: [
    { label: "Site" },
    { label: "Manager" },
    { label: "User" },
    { label: "Status" },
  ],
  dashBoardChart: computed(() => {
    return userStore.dashboardChart;
  }),
  totalPower: 0,
  pageShow: true,
});

const realTimeDataList = computed(() => {
  let list = [] as any[];
  list = userStore.realTimeData.map((item) => {
    return {
      status: item.status,
      switch: item.main_switch_on,
      operation_step: item.operation_step,
      cycle_status: item.cycle_status,
      cycle_count: item.cycle_count,
      dry_time: item.remain_dry_time,
      cooling_time: item.remain_cooling_time,
      discharge_time: item.remain_discharge_time,
      alive: item.alive_count,
      weight:
        optionStore.$state.unitSystem === "metric"
          ? `${item.weight} kg`
          : `${(item.weight * 2.20462).toFixed(2)} lb`,
      energy: `${item.total_active_energy.toFixed(3)} kW`,
      power: `${item.total_active_power.toFixed(3)} kWh`,
      temp:
        optionStore.$state.unitSystem === "metric"
          ? `${item.tank_temperature} ℃`
          : `${celsiusToFahrenheit(item.tank_temperature)} °F`,
      // 추가본
      model: item.model,
    };
  });

  list.forEach((item) => {
    if (item.dry_time !== 0) {
      let dryTime = "";
      const time = item.dry_time;
      const hour = Math.floor(time / 60);
      const minute = time % 60;
      if (hour > 9) {
        if (minute > 9) {
          dryTime = `${String(hour)} : ${String(minute)}`;
        } else {
          dryTime = `${String(hour)} : 0${String(minute)}`;
        }
        item.dry_time = dryTime;
      } else {
        if (minute > 9) {
          dryTime = `0${String(hour)} : ${String(minute)}`;
        } else {
          dryTime = `0${String(hour)} : 0${String(minute)}`;
        }
        item.dry_time = dryTime;
      }
    }
    if (item.dry_time === 0) {
      item.dry_time = `00 : 00`;
    }

    if (item.cooling_time !== 0) {
      let coolingTime = "";
      const time = item.cooling_time;
      const hour = Math.floor(time / 60);
      const minute = time % 60;
      if (hour > 9) {
        if (minute > 9) {
          coolingTime = `${String(hour)} : ${String(minute)}`;
        } else {
          coolingTime = `${String(hour)} : 0${String(minute)}`;
        }
        item.cooling_time = coolingTime;
      } else {
        if (minute > 9) {
          coolingTime = `0${String(hour)} : ${String(minute)}`;
        } else {
          coolingTime = `0${String(hour)} : 0${String(minute)}`;
        }
        item.cooling_time = coolingTime;
      }
    }
    if (item.cooling_time === 0) {
      item.cooling_time = `00 : 00`;
    }
    if (item.discharge_time !== 0) {
      let dryTime = "";
      const time = item.discharge_time;
      const hour = Math.floor(time / 60);
      const minute = time % 60;

      if (hour > 9) {
        if (minute > 9) {
          dryTime = `${String(hour)} : ${String(minute)}`;
        } else {
          dryTime = `${String(hour)} : 0${String(minute)}`;
        }
        item.discharge_time = dryTime;
      } else {
        if (minute > 9) {
          dryTime = `0${String(hour)} : ${String(minute)}`;
        } else {
          dryTime = `0${String(hour)} : 0${String(minute)}`;
        }
        item.discharge_time = dryTime;
      }
    }
    if (item.discharge_time === 0) {
      item.discharge_time = `00 : 00`;
    }
    // Model <= 20 일때 (일반장비)
    if (0 <= item.model && item.model <= 20) {
      if (item.operation_step === 1) {
        item.operation_step = "Operation Init";
      } else if (item.operation_step === 2) {
        item.operation_step = "Operation Ready";
      } else if (item.operation_step === 3) {
        item.operation_step = "Dry Run Check";
      } else if (item.operation_step === 4 || item.operation_step === 5) {
        item.operation_step = "Dry Run";
      } else if (item.operation_step === 6) {
        item.operation_step = "Cooling Down";
      } else if (item.operation_step === 7) {
        item.operation_step = "Dry Run Done";
      } else if (item.operation_step === 8) {
        item.operation_step = "Discharge Ready";
      } else if (item.operation_step === 9) {
        item.operation_step = "Discharge Run Check";
      } else if (item.operation_step === 10) {
        item.operation_step = "Discharge Run";
      } else if (item.operation_step === 11) {
        item.operation_step = "Discharge Run Done";
      } else if (item.operation_step === 12) {
        item.operation_step = "Operation Done";
      } else if (item.operation_step === 20) {
        item.operation_step = "Error";
      } else {
        console.log(`현재 operation_step은 ${item.operation_step}입니다.`);
      }
    } else {
      if (
        item.operation_step === 1 ||
        item.operation_step === 2 ||
        item.operation_step === 3 ||
        item.operation_step === 4 ||
        item.operation_step === 5
      ) {
        item.operation_step = "Operation Init";
      } else if (item.operation_step === 6 || item.operation_step === 7) {
        item.operation_step = "Card Check";
      } else if (
        item.operation_step === 8 ||
        item.operation_step === 9 ||
        item.operation_step === 10 ||
        item.operation_step === 11 ||
        item.operation_step === 12 ||
        item.operation_step === 13
      ) {
        item.operation_step = "Weight Check";
      } else if (item.operation_step === 14) {
        item.operation_step = "Operation Ready";
      } else if (item.operation_step === 15 || item.operation_step === 16) {
        item.operation_step = "Dry Run Check";
      } else if (item.operation_step === 17 || item.operation_step === 18) {
        item.operation_step = "Dry Run";
      } else if (item.operation_step === 19) {
        item.operation_step = "Cooling Down";
      } else if (item.operation_step === 20) {
        item.operation_step = "Dry Run Done";
      } else if (item.operation_step === 21) {
        item.operation_step = "Discharge Ready";
      } else if (item.operation_step === 22) {
        item.operation_step = "Discharge Run Check";
      } else if (item.operation_step === 23) {
        item.operation_step = "Discharge Run";
      } else if (item.operation_step === 24) {
        item.operation_step = "Discharge Run Done";
      } else if (item.operation_step === 25) {
        item.operation_step = "Operation Done";
      } else if (item.operation_step === 40) {
        item.operation_step = "Error";
      } else {
        console.log(`현재 RFID operation_stop은 ${item.operation_step}입니다.`);
      }
    }
  });
  return list;
});

const detailGo = async (mac: string) => {
  const idx = userStore.findMac(mac);

  if (idx === -1) {
    alert(`Adding device...${mac}`);
    return;
  } else {
    await router.push({
      name: ROU_NAME.DETAIL,
      query: { mac: mac },
    });
  }

  console.log("findMac : ", idx);
};

const nextPage = (id: string) => {
  if (state.value.currentPage === state.value.maxPage) {
    return;
  } else {
    boxName.value = `itemBox${id}`;
    state.value.currentPage++;
    state.value.pageShow = !state.value.pageShow;
    setTimeout(() => {
      state.value.pageShow = !state.value.pageShow;
    }, 300);
  }
};
const prevPage = (id: string) => {
  if (state.value.currentPage === 1) {
    return;
  } else {
    boxName.value = `itemBox${id}`;
    state.value.currentPage--;
    state.value.pageShow = !state.value.pageShow;
    setTimeout(() => {
      state.value.pageShow = !state.value.pageShow;
    }, 300);
  }
};

watchEffect(async () => {
  const run = userStore.realTimeData.filter((item) => {
    return item.status === 1 && item.cycle_status === 1;
  });

  const stop = userStore.realTimeData.filter((item) => {
    return item.status === 1 && item.cycle_status === 0;
  });
  const warning = userStore.realTimeData.filter((item) => {
    return (
      (item.cycle_status === 1 && item.status === 3) ||
      (item.cycle_status === 0 && item.status === 3) ||
      (item.cycle_status === 1 && item.status === 2) ||
      (item.cycle_status === 0 && item.status === 2)
    );
  });
  const totalPower = _.sumBy(userStore.realTimeData, "total_active_power");

  state.value.totalPower = totalPower;

  if (run) {
    userStore.dashboardChart[0].value = run.length;
  }
  if (stop) {
    userStore.dashboardChart[1].value = stop.length;
  }
  if (warning) {
    userStore.dashboardChart[2].value = warning.length;

    state.value.warningList = warning.map((item) => {
      return {
        site: item.site_name,
        user: item.user_name,
        manager: item.manager,
        status:
          item.status === 2 ? "Error" : item.status === 3 ? "Connect Loss" : "",
      };
    });
  }
  state.value.maxPage = dashBoardList.value.length;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (_unref(userStore).realTimeData[0])
              ? (_openBlock(), _createBlock(DashBoardChart, {
                  key: 0,
                  data: state.value.dashBoardChart
                }, null, 8, ["data"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, "None Data"))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("total_power")) + " : " + _toDisplayString(state.value.totalPower.toFixed(4)) + " kWh", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("table", _hoisted_14, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.value.header, (val, idx) => {
                      return (_openBlock(), _createElementBlock("th", {
                        class: "warning-th",
                        scope: "col",
                        key: idx
                      }, _toDisplayString(val.label), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.value.warningList, (val, idx) => {
                    return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(val, (val2, idx2) => {
                        return (_openBlock(), _createElementBlock("td", {
                          class: "warning-td",
                          key: idx2
                        }, _toDisplayString(val2), 1))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_TransitionGroup, {
          name: boxName.value,
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (state.value.pageShow)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_unref(Loading), {
                    active: _unref(loadings),
                    "is-full-page": false,
                    "background-color": "#2b323a",
                    color: "#8c98a5",
                    opacity: 0.8
                  }, null, 8, ["active", "opacity"]),
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (prevPage('Prev'))),
                    class: "page-left change",
                    disabled: state.value.currentPage === 1
                  }, [
                    (state.value.currentPage === 1)
                      ? (_openBlock(), _createBlock(AppImage, {
                          key: 0,
                          name: "dashboard_prev_dis"
                        }))
                      : (_openBlock(), _createBlock(AppImage, {
                          key: 1,
                          name: "dashboard_prev"
                        }))
                  ], 8, _hoisted_16),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (nextPage('Next'))),
                    class: "page-right change",
                    disabled: state.value.maxPage === state.value.currentPage
                  }, [
                    (state.value.maxPage === state.value.currentPage)
                      ? (_openBlock(), _createBlock(AppImage, {
                          key: 0,
                          name: "dashboard_next_dis"
                        }))
                      : (_openBlock(), _createBlock(AppImage, {
                          key: 1,
                          name: "dashboard_next"
                        }))
                  ], 8, _hoisted_17),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dashBoardList)[state.value.currentPage - 1], (item, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "machine-card-content",
                      key: idx
                    }, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("site")) + " : " + _toDisplayString(item.site_name), 1)
                      ]),
                      (
                _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)] === undefined
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("div", null, [
                              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("loading")), 1)
                            ])
                          ]))
                        : (
                _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)].status === 1
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("normal")), 1)
                              ])
                            ]))
                          : (
                _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)].status === 3
              )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("error")), 1)
                                ])
                              ]))
                            : (
                _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)].status === 2
              )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("warning")), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", null, [
                          _createVNode(AppImage, {
                            class: "card-item-icon",
                            name: "main_switch_icon"
                          }),
                          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("switch")), 1),
                          (
                    _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)] ===
                    undefined
                  )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.$t("loading")), 1))
                            : (
                    _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)]
                      .switch === 1
                  )
                              ? (_openBlock(), _createBlock(AppImage, {
                                  key: 1,
                                  class: "card-item-icon-value",
                                  name: "switch_on"
                                }))
                              : (
                    _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)]
                      .switch === 0
                  )
                                ? (_openBlock(), _createBlock(AppImage, {
                                    key: 2,
                                    class: "card-item-icon-value",
                                    name: "switch_off"
                                  }))
                                : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", null, [
                          _createVNode(AppImage, {
                            class: "card-item-icon",
                            name: "alive_icon"
                          }),
                          _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("alive_count")), 1),
                          _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)] ===
                  undefined
                    ? _ctx.$t("loading")
                    : _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)].alive), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", null, [
                          _createVNode(AppImage, {
                            class: "card-item-icon",
                            name: "cycle_status"
                          }),
                          _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("cycle_status")), 1),
                          (
                    _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)] ===
                    undefined
                  )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.$t("loading")), 1))
                            : (
                    _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)]
                      .cycle_status === 1
                  )
                              ? (_openBlock(), _createBlock(AppImage, {
                                  key: 1,
                                  class: "card-item-icon-value",
                                  name: "status_icon"
                                }))
                              : (
                    _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)]
                      .cycle_status === 0
                  )
                                ? (_openBlock(), _createBlock(AppImage, {
                                    key: 2,
                                    class: "card-item-icon-value",
                                    name: "status_icon_stop"
                                  }))
                                : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", null, [
                          _createVNode(AppImage, {
                            class: "card-item-icon",
                            name: "cycle_count_icon"
                          }),
                          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t("cycle_count")), 1),
                          _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)] ===
                  undefined
                    ? _ctx.$t("loading")
                    : _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)]
                        .cycle_count), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", null, [
                          _createVNode(AppImage, {
                            class: "card-item-icon",
                            name: "time_icon"
                          }),
                          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t("dry_time")), 1),
                          _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)] ===
                  undefined
                    ? _ctx.$t("loading")
                    : _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)]
                        .dry_time), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", null, [
                          _createVNode(AppImage, {
                            class: "card-item-icon",
                            name: "time_icon"
                          }),
                          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t("cooling_time")), 1),
                          _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)] ===
                  undefined
                    ? _ctx.$t("loading")
                    : _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)]
                        .cooling_time), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(AppImage, {
                          class: "card-item-icon",
                          name: "time_icon"
                        }),
                        _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t("discharge_time")), 1),
                        _createElementVNode("span", _hoisted_48, _toDisplayString(_unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)] === undefined
                  ? _ctx.$t("loading")
                  : _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)]
                      .discharge_time), 1)
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(AppImage, {
                          class: "card-item-icon",
                          name: "weight_icon"
                        }),
                        _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t("weight")), 1),
                        _createElementVNode("span", _hoisted_51, _toDisplayString(_unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)] === undefined
                  ? _ctx.$t("loading")
                  : _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)].weight), 1)
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(AppImage, {
                          class: "card-item-icon",
                          name: "energy_icon"
                        }),
                        _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$t("energy")), 1),
                        _createElementVNode("span", _hoisted_54, _toDisplayString(_unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)] === undefined
                  ? _ctx.$t("loading")
                  : _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)].energy), 1)
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createVNode(AppImage, {
                          class: "card-item-icon",
                          name: "power_icon"
                        }),
                        _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t("power")), 1),
                        _createElementVNode("span", _hoisted_57, _toDisplayString(_unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)] === undefined
                  ? _ctx.$t("loading")
                  : _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)].power), 1)
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(AppImage, {
                          class: "card-item-icon",
                          name: "temp_icon"
                        }),
                        _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t("temperature")), 1),
                        _createElementVNode("span", _hoisted_60, _toDisplayString(_unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)] ===
                  undefined
                    ? _ctx.$t("loading")
                    : _unref(realTimeDataList)[_unref(userStore).findMac(item.mac_addr)].temp), 1)
                      ]),
                      _createElementVNode("button", {
                        class: "detail-move-btn",
                        onClick: ($event: any) => (detailGo(item.mac_addr))
                      }, [
                        _hoisted_62,
                        _createVNode(AppImage, {
                          class: "detail-btn-icon",
                          name: "next_icon"
                        })
                      ], 8, _hoisted_61)
                    ]))
                  }), 128)),
                  (_unref(dashBoardList)[state.value.currentPage - 1].length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t("add_device")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(dashBoardList)[state.value.currentPage - 1].length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.$t("add_device")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(dashBoardList)[state.value.currentPage - 1].length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.$t("add_device")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(dashBoardList)[state.value.currentPage - 1].length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.$t("add_device")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(dashBoardList)[state.value.currentPage - 1].length === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.$t("add_device")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(dashBoardList)[state.value.currentPage - 1].length === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.$t("add_device")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(dashBoardList)[state.value.currentPage - 1].length === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.$t("add_device")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(dashBoardList)[state.value.currentPage - 1].length === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.$t("add_device")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(dashBoardList)[state.value.currentPage - 1].length === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.$t("add_device")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(dashBoardList)[state.value.currentPage - 1].length === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.$t("add_device")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["name"])
      ])
    ])
  ], 64))
}
}

})